import { render } from "./reset_password_sent.html?vue&type=template&id=522e04e0&external"
import script from "./reset_password_sent.js?vue&type=script&lang=js&external"
export * from "./reset_password_sent.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__